export default {
  methods: {
    getEducationLevelBackgroundColor (type) {
      switch (true) {
        case type.includes('PAUD'): return 'background-color: #fd75aa'
        case type.includes('TK'): return 'background-color: #25b9fb'
        case type.includes('SD'): return 'background-color: #d00000'
        case type.includes('SMP'): return 'background-color: #0041b4'
        case type.includes('SMK'): return 'background-color: #91abbe'
        case type.includes('SMA'): return 'background-color: #91abbe'
      }
    },
    getProductStatusBackgroundColor (type) {
      switch (true) {
        case type.includes('NEW'): return 'background-color: #8BC63F'
        case type.includes('OOS'): return 'background-color: #ed1c24'
        case type.includes('LOCAL'): return 'background-color: #557B24'
        case type.includes('UMKM'): return 'background-color: #4F3589'
      }
    },
    getProductStatusText (type) {
      switch (true) {
        case type.includes('NEW'): return this.$t('app.homepage.product.new_arrival.new_label')
        case type.includes('OOS'): return this.$t('app.homepage.product.oos.label')
        case type.includes('LOCAL'): return this.$t('app.product.item.local_product')
        case type.includes('UMKM'): return this.$t('app.product.item.umkm_product')
      }
    }
  }
}
